<template>
  <el-table :data="cases.data" highlight-current-row key="aTable">
    <el-table-column :label="$t('No.')" type="index" width="100"></el-table-column>
    <el-table-column show-overflow-tooltip :label="$t('Case Title')" prop="case_title" width="400">
      <template slot-scope="scope">
        <router-link :to="gotoDetail(scope.row)">{{ scope.row.case_title }}</router-link>
      </template>
    </el-table-column>
    <el-table-column
      :label="$t('Fachstellen Name')"
      prop="fachstellen_name"
      v-if="!$store.state.config.user.fachstellen_slug"
      width="300"
    >
      <template slot-scope="scope">
        <router-link
          :to="{name: 'FachstellenDashboard', params: {'fachstellen_slug': scope.row.fachstellen_slug }}"
          v-if="$store.getters.getConfig('has_permissions').includes('fachstellens-index')"
        >{{ scope.row.fachstellen_name }}</router-link>
        <span v-else>{{ scope.row.fachstellen_name }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('Godchild')" prop="patenkinder_name" width="250"></el-table-column>
    <el-table-column :label="$t('Status')" prop="status" width="190">
      <template slot-scope="scope">
        <el-tag
          size="mini"
          :type="getStatusType(scope.row.status_key)"
          v-if="scope.row.is_new_case==0"
        >{{ $t(scope.row.status_key) }}</el-tag>
        <el-tag size="mini" type="danger" v-else>
          <h4>{{ $t('Erstaufnahme')}}</h4>
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column
      :label="$t('Votes')"
      width="150"
      v-if="$store.state.config.user.role_slug.indexOf('fachstellen') < 0"
    >
      <template slot-scope="scope">
        <el-tag size="mini" type="success" class="vote-status-thumb">
          {{
          scope.row.case_up_votes }}
          <i class="icon-up-votes"></i>
        </el-tag>
        <el-tag size="mini" type="danger" class="vote-status-thumb">
          {{
          scope.row.case_down_votes }}
          <i class="icon-down-votes"></i>
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column :label="$t('Created at')" prop="created_at" min-width="250">
      <template slot-scope="scope">
        <span v-date-time-format="scope.row.created_at"></span>
      </template>
    </el-table-column>

    <el-table-column :label="$t('Expected amount')" prop="expected_amount" min-width="240">
      <template slot-scope="scope">{{ scope.row.expected_amount | currency-format}}</template>
    </el-table-column>

    <el-table-column :label="$t('Confirmed Amount')" prop="approved_amount" min-width="240">
      <template slot-scope="scope">{{ scope.row.approved_amount | currency-format}}</template>
    </el-table-column>

    <el-table-column :label="$t('payment_date')" prop="payment_date" min-width="250">
      <template slot-scope="scope">
        <span v-if="scope.row.payment_date" v-date-format="scope.row.payment_date"></span>
        <span v-else></span>
      </template>
    </el-table-column>

    <el-table-column :label="$t('payment_status')" prop="payment_status" width="190">
      <template slot-scope="scope">
        <el-tag size="mini" type="warning" v-if="scope.row.payment_status==1">
          <h4>{{ $t('paid')}}</h4>
        </el-tag>
        <el-tag size="mini" type="danger" v-else>
          <h4>{{ $t('unpaid')}}</h4>
        </el-tag>
      </template>
    </el-table-column>

    <el-table-column :label="$t('Modified at')" prop="updated_at" min-width="250">
      <template slot-scope="scope">
        <span v-date-time-format="scope.row.updated_at "></span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    patenkind_slug: String
  },
  data() {
    return {
      cases: {
        meta: {},
        data: []
      }
    };
  },
  mounted() {
    this.getCases();
  },
  methods: {
    gotoDetail(tab) {
      if (
        tab.status_key == "stage_1" ||
        tab.status_key == "donated" ||
        tab.status_key == "rejected"
      ) {
        return {
          name: "CaseDetails",
          params: {
            id: tab.id
          }
        };
      } else if (tab.status_key == "stage_2") {
        return {
          name: "CaseDetails",
          params: {
            id: tab.id
          }
        };
      } else {
        return {
          name: "CaseDetails",
          params: {
            id: tab.id
          }
        };
      }
    },
    getStatusType(status_key) {
      var statusType = "";
      switch (status_key) {
        case "stage_1":
          statusType = "info";
          break;
        case "stage_2":
          statusType = "warning";
          break;
        case "stage_3":
          statusType = "";
          break;
        case "donated":
          statusType = "success";
          break;
        default:
          statusType = "danger";
      }
      return statusType;
    },
    getCases() {
      request({
        url: "patenkinder-cases",
        method: "get",
        params: {
          pagination: false,
          sortBy: "id",
          order: "desc",
          patenkinder_slug: this.patenkind_slug
        }
      }).then(response => {
        this.cases = response.data;
      });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Layout/Cases/PatenkindCases.vue